export default {
  title: 'Dwarf',
  content: ['New ability: Mace Specialization: Increases your skill with maces by 5.'],
}
